import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F3FDFD25-C4F6-4ECF-8F8B-C460E4C6BD7C
 * name molecule-co
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/molecule-co.svg
 * tags
 * - Home Automation 
 * - Science 
 */
export const MoleculeCoIcon = createSvgIcon(<><path d="M8 7C6.9 7 6 7.9 6 9V15C6 16.11 6.9 17 8 17H11V15H8V9H11V7H8M14 7C12.9 7 12 7.9 12 9V15C12 16.11 12.9 17 14 17H16C17.11 17 18 16.11 18 15V9C18 7.9 17.11 7 16 7H14M14 9H16V15H14V9" /></>, 'MoleculeCoIcon');
export default MoleculeCoIcon